import { useMediaQuery, Box, Drawer, useTheme, IconButton } from '@mui/material';
import SidebarItems from './SidebarItems';
import Logo from '../../shared/logo/Logo';

import { Profile } from './SidebarProfile/Profile';

import { useAppDispatch, useAppSelector, RootState } from '@shared/store';
import { actions } from '@shared/store/ducks';
import Scrollbar from '@shared/components/custom-scroll/Scrollbar';
import { IconPanelLeft } from '@shared/assets/images/svgs';

const Sidebar = () => {
  const lgUp = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));
  const customizer = useAppSelector((state: RootState) => state.customizer);
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const toggleWidth =
    customizer.isCollapse && !customizer.isSidebarHover
      ? customizer.MiniSidebarWidth
      : customizer.SidebarWidth;

  const handleExpandSidebar = () => {
    if (lgUp && customizer.isCollapse) {
      dispatch(actions.customizer.toggleSidebar());
    }
  };
  return (
    <Box
      sx={{
        width: lgUp ? toggleWidth : 0,
        flexShrink: 0,
        ...(lgUp &&
          customizer.isCollapse && {
            position: 'absolute',
          }),
      }}>
      {/* ------------------------------------------- */}
      {/* Sidebar for desktop */}
      {/* ------------------------------------------- */}
      <Drawer
        anchor="left"
        open={lgUp || Boolean(customizer.isMobileSidebar)}
        onClose={() => dispatch(actions.customizer.setMobileSidebar(false))}
        onClick={handleExpandSidebar}
        variant={lgUp ? 'permanent' : 'temporary'}
        PaperProps={{
          sx: {
            transition: theme.transitions.create('width', {
              duration: theme.transitions.duration.shortest,
            }),
            backgroundColor: theme.palette.extendedGrey?.lighter,
            width: lgUp ? toggleWidth : customizer.SidebarWidth,
            boxSizing: 'border-box',
          },
        }}>
        {/* ------------------------------------------- */}
        {/* Sidebar Box */}
        {/* ------------------------------------------- */}
        <Box
          sx={{
            height: '100%',
          }}>
          {/* ------------------------------------------- */}
          {/* Logo */}
          {/* ------------------------------------------- */}
          <Box
            px={3}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            <Logo />
            {lgUp && !customizer.isCollapse && (
              <IconButton
                aria-label="Collapse navigation"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  dispatch(actions.customizer.toggleSidebar());
                }}>
                <IconPanelLeft />
              </IconButton>
            )}
          </Box>
          <Scrollbar sx={{ height: 'calc(100% - 190px)' }}>
            {/* ------------------------------------------- */}
            {/* Sidebar Items */}
            {/* ------------------------------------------- */}
            <SidebarItems />
          </Scrollbar>
          <Profile />
        </Box>
      </Drawer>
    </Box>
  );
};

export default Sidebar;
